exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4 {\r\n    margin: 0;\r\n}\r\n\r\np {\r\n    margin-top: 0;\r\n}\r\n\r\n/*.seccion-info-right {\r\n\tmargin-top: 90px;\r\n}*/\r\n\r\n.help-seccion {\r\n\toverflow: auto;\r\n    max-height: 350px;\r\n\tfont-size: 13px;\r\n    word-break: word-break;\r\n    /*text-transform: capitalize;*/    \r\n}\r\n\r\n.show-seccion {\r\n    border: 3px solid #41d78c;\r\n    border-radius: 5px;\r\n}\r\n\r\n.save-button {\r\n    border: 1px solid #41d78c;\r\n}\r\n\r\n.container-form {\r\n    height: 100%;\r\n    max-height: 70vh;\r\n    overflow: hidden;\r\n}\r\n\r\n.container-form:hover {\r\n    overflow: auto;\r\n}\r\n\r\n.container-info-right {\r\n    height: 100%;\r\n    max-height: 70vh;\r\n    overflow: hidden;\r\n}\r\n\r\n.container-info-right:hover {\r\n    overflow: auto;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/contenedor-formulario/contenedor-formulario.component.css
// module id = ../../../../../src/app/components/formulario-no-experto/contenedor-formulario/contenedor-formulario.component.css
// module chunks = main